export const api = process.env.REACT_APP_API;
export const API_VERSIONS = {
  d3ck: "d3ck",
  cityportal: "cityportal",
};
